module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Introduction"
    }
  }, [_c('p', {
    staticClass: "fm_tit",
    attrs: {
      "id": "intro1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rintro1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvii",
      "title": "xvii"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm_tit1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rintro1"
    }
  }, [_c('i', [_vm._v("Why This Book?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("ime is all we have.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So why should you allocate a part of your most precious asset on engaging with this book?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because my hope is that it will leave you seeing, thinking, and feeling differently about how to grow and remain relevant in transformative times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How to grow yourself, grow those around you, and grow your practice, passion, or company.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How to remain relevant by understanding what it takes to make sense and thrive in a world of rapid technological, demographic, and global upheaval.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("And it will do so by questioning much of what business takes for granted:")]), _vm._v(" "), _c('p', {
    staticClass: "bulleta"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "blist"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "hide"
  }), _vm._v("why data is often not the way forward and we may have too much of it;")]), _vm._v(" "), _c('p', {
    staticClass: "bulleta"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "blist"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "hide"
  }), _vm._v("why change sucks;")]), _vm._v(" "), _c('p', {
    staticClass: "bulleta"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "blist"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "hide"
  }), _vm._v("why having more—rather than fewer—meetings is better; and")]), _vm._v(" "), _c('p', {
    staticClass: "bulleta"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "blist"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "hide"
  }), _vm._v("why it is essential to have a culture and courage that calls out “the turd on the table.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("You not only will learn what makes great leaders but also how to deal with, or not become, a bad boss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You’ll discover how to extract meaning from data and see poetry in the plumbing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book recognizes that while our world is increasingly filled with digital, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xviii",
      "title": "xviii"
    }
  }, [_vm._v("silicon-based, computing objects, it is populated by people who remain analog, carbon-based, feeling creatures.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("People like you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Companies can choose to upgrade the skills of their people and reimagine the way they work or swap out their people and acquire new ways of working.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Often both are necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is about upgrading the operating systems of people and companies by remembering the thinking-and-feeling component of the operating system. A central premise is that successful individuals and firms can never forget the importance of people, their emotions, the culture of the organization, and what cannot be measured. I refer to this as the Soul of a Company. This Soul is critical even as individuals and firms reinvent themselves for an increasingly AI-augmented, data-driven, networked and distributed, screen-based future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the world becomes more data driven and real-time twitchy, and as financial markets punish companies for failing to meet their goals, I worry that our short-term focus on numbers is destroying the long-term health of business, countries, and people. I worry we are losing our humanity in a world where modern, data-driven economies and cutting-edge technologies are seeping into all of life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, results, data, speed, and technology are keys for businesses to remain relevant and thrive. But while they’re necessary, they’re insufficient for long-term success.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over the past five years, I have seen a significant tilt to the numeric, to the algorithmic, and to the measurable. This causes organizations to think short term, prize individualism, and adopt a mercenary mindset rather than think long term, prize teams, and adopt a meaningful mindset.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Increasingly there is a premium and a dominance on the quantitative, or what I call the "), _c('i', [_vm._v("spreadsheet")]), _vm._v(", and a diminishment of the importance of the culture, humanity, emotion, and complexity of people, or what I refer to as the "), _c('i', [_vm._v("story")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Successful people and companies combine the story and the spreadsheet and by doing so restore the soul of business.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lest you think I’m an antitech zealot who believes we should go back to a kinder, gentler, analog time, let me tell you a little about myself. I grew up "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xix",
      "title": "xix"
    }
  }, [_vm._v("in Bombay, India, receiving a degree in economics and advanced mathematics from the University of Bombay. I then came to the United States and received an MBA in marketing and finance from one of the most quantitative schools in the world: the University of Chicago.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over a thirty-seven-year career at the companies of the Publicis Groupe, an eighty-thousand-person global marketing and business transformation firm, I helped found or cofound some of the first digital agencies and future-oriented strategic consultancies as well as contributing to the shaping and growth of one of the two largest buyers of digital, data-driven media in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have served as chairman of major global digital- and e-commerce-oriented firms such as Digitas for Publicis and served as a chief strategist and chief growth officer for Publicis Groupe, while also serving as a trusted advisor to many of our clients’ reinventions and reimaginings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I relate this short history to establish my credentials in the data-driven, digital space. I am obviously someone who believes in digital change. Not so obviously, I also believe in the power of people to make transformation work. As much as I value data, devices, and software, I value empathy, innovation, and relationships.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My career has been about change. Seeing it, managing it, and adapting to it. Change requires adopting the latest technology, but it also requires maximizing the best qualities of people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My career has also been about reinvention—reinventing companies as well as myself. Reinvention involves implementing state-of-the-art software and digital processes that produce something new, but it also involves getting people to embrace the new and enhance it with their ideas and actions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ve led transformation efforts both in the US and in countries throughout the world and earned a reputation as a digital pioneer, while also being known as someone who has helped inspire and grow talent. The two roles are not incompatible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is a book about the future, fed by the best of the past.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A book about cool data that does not forget warm humanity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A book that believes business can and should have a soul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is nearly forty years of learning distilled into two hundred pages that answer the dozen questions I have consistently been asked in the last few years—regardless of country, industry, or age of the person asking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xx",
      "title": "xx"
    }
  }, [_vm._v("Often people asked if there was a book they could buy with the answers. There was not. Until now.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Restoring the Soul of Business")]), _vm._v(" has been written to allow you to read any chapter in any order, since no writer can know what will be most relevant to each reader at each stage. You are in control, and in this way I respect your time, since that is all we have.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hopefully I will get some of yours.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68e04734","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9781400210664_Introduction.vue
// module id = 78
// module chunks = 0